import React, { Component } from 'react';
import { FormattedMessage, FormattedDate } from 'react-intl';

import { trialShape } from '../../types';
import TrialDetailsList from '../trial/TrialDetailsList';

class DetailsHeader extends Component {
  static renderDetails = (trial) => {
    const rows = [
      [
        <span key="span1">
          <FormattedMessage id="trials.trialName" />
          :
          {' '}
          {trial.name}
        </span>,
        <span key="span2">
          <FormattedMessage id="trials.trialCode" />
          :
          {' '}
          {trial.code}
        </span>,
      ],
      [
        <span key="span3">
          <FormattedMessage id="trials.startDate" />
          :
          {' '}
          <FormattedDate value={trial.startDate} />
        </span>,
        <span key="span4">
          <FormattedMessage id="trials.endDate" />
          :
          {' '}
          <FormattedDate value={trial.endDate} />
        </span>,
      ],
      [
        <span key="span5">
          <FormattedMessage id="trials.numSamples" />
          :
          {' '}
          {trial.samples}
        </span>,
        <span key="span6">
          <FormattedMessage id="trials.samplesDelivered" />
          :
          {' '}
          {trial.deliveries || '0'}
          {' '}
          /
          {' '}
          {trial.enrollments}
        </span>,
      ],
      [
        <span key="span7">
          <FormattedMessage id="trials.numParticipants" />
          :
          {' '}
          {trial.enrollments || '0'}
          {' '}
          /
          {' '}
          {trial.participants}
        </span>,
      ],
    ];

    return (
      <TrialDetailsList
        rows={rows}
      />
    );
  };

  render() {
    const { trial } = this.props;
    return (
      <div className="pa3">
        {DetailsHeader.renderDetails(trial)}
      </div>
    );
  }
}

DetailsHeader.propTypes = {
  trial: trialShape.isRequired,
};

export default DetailsHeader;
